import { YieldType } from "../../../globalTypes";
import { DATA_UPDATED_FILL_COLOR, DATA_UPDATED_FONT_COLOR } from "../../../globalValues";

interface EditedYieldCellStylesArgs {
  table: Excel.Table;
  row: number;
  column: number;
  updatedYield: YieldType;
}

export const editedYieldCellStyles = ({ table, row, column, updatedYield }: EditedYieldCellStylesArgs) => {
  if (updatedYield === YieldType.ASK) {
    const askCell = table.columns.getItemAt(column).getRange().getCell(row, 0);

    askCell.format.fill.color = DATA_UPDATED_FILL_COLOR;
    askCell.format.font.color = DATA_UPDATED_FONT_COLOR;
  }

  if (updatedYield === YieldType.BID) {
    const bidCell = table.columns.getItemAt(column).getRange().getCell(row, 0);
    bidCell.format.fill.color = DATA_UPDATED_FILL_COLOR;
    bidCell.format.font.color = DATA_UPDATED_FONT_COLOR;
  }
};
